import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UIKitSquareButton } from './square-button.directive';

@NgModule({
  declarations: [UIKitSquareButton],
  imports: [
    CommonModule
  ],
  exports: [UIKitSquareButton]
})
export class UIKitSquareButtonModule { }
